import { Injectable, signal } from '@angular/core';

export interface NewsArticle {
  id: string;
  title: string;
  category: 'Patch Notes' | 'Esports' | 'Community' | 'New Game';
  timestamp: string;
  image: string;
  content: string;
  author?: string;
  gallery?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private articlesList = signal<NewsArticle[]>([
    {
      id: 'spades-released',
      title: 'New Game Released: Spades',
      category: 'New Game',
      timestamp: '2h ago',
      image: '/images/featured/new-game-spades.png',
      author: 'Rival Forge Team',
      content: `
        <p>Get ready to bid, partner up, and play one of the world's most beloved card games! We are absolutely thrilled to announce that <strong>Spades</strong> has officially joined the Rival Forge game roster.</p>
        <p>Experience the classic trick-taking card game with real-time multiplayer, custom rules, and a fully polished, immersive arena interface. Bring your teammate, count your bids, and avoid the sandbags! Custom table sizing and optional blind bidding let you tailor the game to your group's preferred style.</p>
        <p>Jump into a Spades lobby now and show everyone who rules the deck. Let the bidding begin!</p>
      `,
      gallery: [
        '/images/featured/new-game-spades.png'
      ]
    },
    {
      id: 'madrid-masters',
      title: 'RIVAL FORGE Arena Masters: Madrid',
      category: 'Esports',
      timestamp: '1d ago',
      image: 'https://picsum.photos/seed/esports/800/600',
      author: 'Esports Committee',
      content: `
        <p>The countdown to the next major esports showdown has begun! Rival Forge Arena Masters: Madrid brings the top 16 teams from around the globe to battle it out live on stage.</p>
        <p>With a massive prize pool, intense match-ups, and legendary rivalries, this is an event you cannot afford to miss. Tune in live this weekend to watch history in the making and claim exclusive in-game drops!</p>
      `
    },
    {
      id: 'community-spotlight',
      title: 'Community Spotlight: Best Plays',
      category: 'Community',
      timestamp: '2d ago',
      image: 'https://picsum.photos/seed/community/800/600',
      author: 'Community Team',
      content: `
        <p>Our community continues to amaze us with incredible plays, high-IQ outplays, and hilarious moments! In this week's spotlight, we showcase the top community-submitted clips.</p>
        <p>From clutch last-second turnarounds to flawless trick plays, check out what your fellow Rival Forge players have been up to. Want to see your play featured? Submit your clips in the Discord channel!</p>
      `
    },
    {
      id: 'patch-notes-1-0',
      title: 'Patch Notes 1.0',
      category: 'Patch Notes',
      timestamp: '3d ago',
      image: '/images/featured/patch-notes-cover.png',
      author: 'RivalForge Team',
      content: `
        <p>Hey everyone,</p>
        <p>We’ve rolled out a pretty big update focused on making RivalForge more social, expressive, and customizable. Here’s what’s new:</p>

        <h5 class="fw-bold mt-4 mb-2 text-white">Social & Messaging</h5>
        <ul>
          <li>Direct messaging (Pagers) is now live</li>
          <li>Add/remove friends system implemented</li>
          <li>External links in chat now show a security confirmation before opening</li>
        </ul>

        <h5 class="fw-bold mt-4 mb-2 text-white">Chat Enhancements</h5>
        <ul>
          <li>Link support in chat messages</li>
          <li>Giphy support for sending GIFs in chat</li>
          <li>Text zoom in/out options for better readability</li>
          <li>Option to clear chat locally on your device</li>
        </ul>

        <h5 class="fw-bold mt-4 mb-2 text-white">Lobbies & Rooms</h5>
        <ul>
          <li>Lobby/room images, titles, and descriptions can now be updated</li>
          <li>Lobby owners can upload images for use as room/lobby visuals</li>
        </ul>

        <h5 class="fw-bold mt-4 mb-2 text-white">Profiles</h5>
        <ul>
          <li>You can now change your profile portrait</li>
        </ul>

        <p class="mt-4">This update is a big step toward making RivalForge more customizable and socially connected. More improvements are already in the pipeline, so feedback is always welcome.</p>
        <p>Thanks for playing and helping shape the platform.</p>
        <p class="fw-bold text-muted">— The RivalForge Team</p>
      `
    }
  ]);

  announcements = this.articlesList.asReadonly();

  getArticle(id: string): NewsArticle | undefined {
    return this.articlesList().find(article => article.id === id);
  }

  getRecentArticles(excludeId: string, limit: number = 3): NewsArticle[] {
    return this.articlesList()
      .filter(article => article.id !== excludeId)
      .slice(0, limit);
  }
}
